import { Component, OnInit } from '@angular/core';
import { FondosService } from './services/fondos.service';
import { Fondo } from './interfaces';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

}
